module.exports = __webpack_public_path__ + "img/47a2fbd.jpg";